<template>
  <div class="contenido-rutinas bg-primary">
    <transition name="router-anim" mode="out-in">
      <div :key="1" v-if="step == 0">
        <Dias @dia="selectDia" :diassemana="dias"/>
      </div>
      <div :key="2" v-else-if="step == 1">
        <Objetivos @objetivo="selectObjetivo" :objetivos="objetivos"/>
      </div>
    </transition>
  </div>
</template>

<script>
import Dias from "./Dias";
import Objetivos from "./Objetivos";
export default {
  data() {
    return {
      dias: [],
      objetivos: [],
      url: "",
      step: 0,
      diaSelected: null,
      objetivoSelected: null
    };
  },
  components: {
    Objetivos,
    Dias
  },
  created() {
    this.url =
      window.location.host == "localhost:8082"
        ? "http://localhost:8080/api/"
        : "https://fivogym.es/api/";
    this.getDias();
    this.getObjetivos();
  },
  methods: {
    selectDia(dia) {
      this.diaSelected = dia;
      this.step = 1;
    },
    selectObjetivo(objetivo) {
      this.objetivoSelected = objetivo;
      this.downloadPdf();
    },
    downloadPdf() {
      let d = `${this.url}downloadPdf/${this.diaSelected.id}/${
        this.objetivoSelected
      }`;
      // console.log(d);
      axios({
        url: d,
        method: "GET",
        responseType: "arraybuffer" // important
      }).then(response => {
          console.log(response.data);
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = 'guia_ejercicios.pdf'
        link.click();
      });
    },
    getDias() {
      axios.get(`${this.url}dias`).then(res => {
        this.dias = res.data.dias;
      });
    },
    getObjetivos() {
      axios.get(`${this.url}objetivos`).then(res => {
        this.objetivos = res.data.objetivos;
      });
    }
  }
};
</script>
<style>
.contenido-rutinas {
  min-height: calc(100vh - 70px);
}

.router-anim-enter-active {
  animation: coming 0.5s;
  animation-delay: 0.1s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 0.5s;
}
</style>
